import axios from 'axios';

import { clearAuthToken } from './utils';

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      clearAuthToken();
      window.location.reload();
    }
    return Promise.reject(error);
  },
);

export default axios;
